import { RandomUtils } from '../utils/random-utils';

export enum RequestTypeEnum {
  ACTIVITY = 'ACTIVITY',
  COMPETENCE = 'COMPETENCE',
}

export const requestTypeTranslation = (type: RequestTypeEnum): string | null => {
  switch (type) {
    case RequestTypeEnum.ACTIVITY.toString():
      return 'Activité';
    case RequestTypeEnum.COMPETENCE.toString():
      return 'Compétence';
    default:
      return null;
  }
};

export const requestTypeEnumObject = (type: RequestTypeEnum) => ({
  _id: RandomUtils.generateId(),
  value: type,
  label: requestTypeTranslation(type),
});

export const requestTypeOptions = Object.values(RequestTypeEnum).map(requestTypeEnumObject);
